import React, { useState, useEffect } from "react";
import Web3 from 'web3';
import Cookies from "universal-cookie";
import { toast, Bounce } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import Loader from "../../components/Loader.js";
import web3Config from "../../web3/web3Config.json";
import { logo } from '../../assets/svg/svg'
import { CompleteLoader } from '../../modals/common-alert';
import { Signature } from '../../modals/SignatureModal.js';
import { transactionAction } from '../../helper/chain-helper';
import { getHostHelperContract } from '../../helper/contract-helper';
import { getGeneralSettings, timeZone } from '../../helper/settingsHelper.js';
import TimezoneSelect from 'react-timezone-select';

const cookies = new Cookies();

const SettingRow = ({ label, description, children, minWidth = '130px' }) => (
    <div className="d-flex flex-column flex-xl-row align-items-xl-center gap-2 gap-md-4 setting-cards border-bottom-F0F0F0">
        <div style={{ minWidth }}>
            <h3 className="setting-labels">{label}</h3>
            {description && <h5>{description}</h5>}
        </div>
        <div className="d-flex align-items-center gap-2 flex-grow-1">{children}</div>
    </div>
);

const RadioOption = ({ name, id, label, checked, onChange }) => (
    <div className="d-flex align-items-center gap-2">
        <input
            className="input-radio"
            type="radio"
            name={name}
            id={id}
            checked={checked}
            onChange={onChange}
        />
        <label htmlFor={id} className="text-black block redio-label">{label}</label>
    </div>
);

const accountSettings = [
    { label: "Save all sent emails", key: 'isSaveSent', type: 'radio', group: 'saveSent' },
    { label: "Send Secure Email To Web2 User", key: 'isSecureSent', type: 'radio', group: 'saveSecure' },
    { label: "Include Previous Messages", key: 'isIncludePrevious', type: 'radio', group: 'includePrevious' },
    { label: "Web2 Inbox", key: 'isWeb2Inbox', type: 'radio', group: 'web2Inbox' },
    { label: "Group Email", key: 'isGrouped', type: 'radio', group: 'grouped' },
    { label: "Check Spelling", key: 'isSpellChecked', type: 'radio', group: 'spellChecked' },
    { label: "Time Zone", key: 'zone', type: 'select' },
];

const General = () => {
    const [settings, setSettings] = useState(accountSettings.map(setting => ({
        ...setting,
        value: setting.type === 'radio' ? false : 'system'
    })));
    const [isOpen, setIsOpen] = useState(false);
    const [allSettings, setAllSettings] = useState([]);
    const [account, setAccount] = useState('');
    const [loader, setLoader] = useState(false);
    const [sectionLoader, setSectionLoader] = useState(false);
    const [web3Value, setWeb3] = useState(null);
    const [user] = useState(cookies.get("userObject"));
    const dispatch = useDispatch();
    const [buttonText, setButtonText] = useState('Save Changes');
    const refreshSettings = useSelector((state) => state.refreshSettings);

    useEffect(() => {
        if (window.ncogProvider) {
            const web3Instance = new Web3(web3Config?.CHAIN_DETAILS?.rpcUrls[0]);
            setWeb3(web3Instance);
            const walletAddress = localStorage.getItem("walletAddress");
            setAccount(walletAddress);
        } else {
            console.log('NCOG is not installed');
        }
        fetchdata();
    }, []);

    async function fetchdata() {
        setSectionLoader(true);
        try {

            const helperContract = getHostHelperContract();
            const getSettings = await helperContract.methods.getSettings(user.name).call();
            const generalSettings = await getGeneralSettings(user);

            const updatedSettings = accountSettings.map(setting => {
                return {
                    ...setting,
                    value: generalSettings[setting.key]
                }
            });

            setSettings(updatedSettings);
            setAllSettings(getSettings);
            setSectionLoader(false);
        } catch (err) {
            console.log(err);

        }
    }

    const handleChange = (key, newValue) => {
        const updatedSettings = settings.map(setting => {
            if (setting.key === key) {
                return { ...setting, value: newValue };
            }
            return setting;
        });
        setSettings(updatedSettings);
    };

    const saveGeneral = async () => {
        setLoader(true);
        setButtonText("Processing...");

        const options = settings.map((setting) => {
            return {
                key: setting.key,
                value: setting?.value ? setting?.value.toString() : ''
            }
        });
        const helperContract = getHostHelperContract();
        const functionParams = [user.name, 'general', options];
        const hash = await transactionAction(helperContract, "updateSettings", functionParams, account, 'helper');
        setButtonText('loading...');
        if (hash) {
            setButtonText("success");
            setButtonText("Saved");
            dispatch({ type: "REFRESH_SETTINGS", payload: !refreshSettings });
            toast.success("Successfully updated.", {
                position: "top-center",
                transition: Bounce,
            });
        } else {
            setButtonText("Save Changes")
            toast.error("Something went wrong.", {
                position: "top-center",
                transition: Bounce,
            });
        }
        setButtonText("Save Changes");
        await fetchdata();
        setLoader(false);
    }

    const getSettingValue = (key) => {
        const setting = settings.find(s => s.key === key);
        return setting ? setting.value : null;
    };

    return (
        <div>
            {!sectionLoader ? (
                <div>
                    {settings.map((setting, index) => (
                        <SettingRow key={index} label={setting.label}>
                            {setting.type === 'radio' ? (
                                <>
                                    <div className="flex-column gap-2 d-none d-md-flex">
                                        <RadioOption
                                            name={setting.group}
                                            id={`${setting.group}On`}
                                            label="On"
                                            checked={getSettingValue(setting.key) === true || getSettingValue(setting.key) === 'true'}
                                            onChange={() => handleChange(setting.key, true)}
                                        />
                                        <RadioOption
                                            name={setting.group}
                                            id={`${setting.group}Off`}
                                            label="Off"
                                            checked={getSettingValue(setting.key) === false || getSettingValue(setting.key) === 'false'}
                                            onChange={() => handleChange(setting.key, false)}
                                        />
                                    </div>
                                    <select
                                        className="multiSelectOption-items d-block d-md-none"
                                        value={getSettingValue(setting.key) ? 'On' : 'Off'}
                                        onChange={(e) => handleChange(setting.key, e.target.value === 'On')}
                                    >
                                        <option>On</option>
                                        <option>Off</option>
                                    </select>
                                </>
                            ) : setting.type === 'select' ? (
                                <TimezoneSelect
                                    value={getSettingValue('zone') !== 'system' ? getSettingValue('zone') : Intl.DateTimeFormat().resolvedOptions().timeZone}
                                    onChange={(tz) => handleChange('zone', tz?.value)}
                                    className="timezone-input"
                                    //add inside element class
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            border: 'none',
                                            boxShadow: 'none',
                                            outline: 'none',
                                            // backgroundColor: 'transparent',
                                            padding: '0',
                                            color: '#000',
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Poppins',
                                            width: '20rem'
                                        }),
                                        menu: (baseStyles, state) => ({
                                            ...baseStyles,
                                            border: 'none',
                                            boxShadow: 'none',
                                            outline: 'none',
                                            // backgroundColor: 'transparent',
                                            padding: '0',
                                            color: '#000',
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Poppins',
                                        }),
                                        // option: (baseStyles, state) => ({
                                        //     ...baseStyles,
                                        //     border: 'none',
                                        //     boxShadow: 'none',
                                        //     outline: 'none',
                                        //     // backgroundColor: 'transparent',
                                        //     padding: '0',
                                        //     color: '#000',
                                        //     fontSize: '14px',
                                        //     fontWeight: '400',
                                        //     fontFamily: 'Poppins',
                                        // }),
                                    }}
                                />
                            ) : null}
                        </SettingRow>
                    ))}

                    <SettingRow label="Signature">
                        <button
                            className='sign-edit-btn cursor-pointer'
                            onClick={() => setIsOpen(true)}
                        >
                            <span className='mt-1'>{logo.edit_icon_light}</span>
                        </button>
                    </SettingRow>

                    <div className='save-settings-btn mt-4'>
                        <button onClick={saveGeneral}>
                            <span>{buttonText}</span>
                        </button>
                    </div>
                </div>
            ) : (
                <Loader normal={true} />
            )}

            <Signature
                isOpen={isOpen}
                close={() => { setIsOpen(false); fetchdata() }}
                loader={setLoader}
                settings={allSettings}
                user={user}
                account={account}
            />
            <CompleteLoader
                isOpen={loader}
                text={"Please wait while the settings are being updated on the blockchain."}
            />
        </div>
    );
}

export default General;